<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <section class="bg-teal-100 py-4 px-2 p-md-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 d-flex flex-column align-items-start justify-content-center">
            <span class="hero-title pb-0 pb-md-2">{{t('about.us.this.is')}} Tracey</span>
            <div class="col-12 col-md-6 d-flex d-md-none">
              <img [src]="introAssetUrl" alt="" class="img-fluid">
            </div>
            <h3 class="d-md-inline-block d-none">
              {{t('about.us.tracey')}} </h3>
            <p class="d-md-none d-inline-block">{{t('about.us.tracey')}} </p>
          </div>
          <div class="col-12 col-md-6 d-none d-md-flex">
            <img [src]="introAssetUrl" alt="" class="img-fluid">
          </div>
        </div>
      </div>
    </section>

    <section class="grey-neutral-50-bg py-4 mb-4">
      <div class="container">
        <div class="row pb-md-2 pb-3">
          <div class="col-12 col-md-6">
            <p class="fw-medium pb-3">
            {{t('about.us.modules.title')}}
            </p>
            <p>
              {{t('about.us.modules.content.1')}}
            </p>
            <p>
              {{t('about.us.modules.content.2')}}
            </p>
          </div>
          <div class="col-12 col-md-6"></div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="mobile-subtitle fs-18 fw-medium mt-3 d-flex d-md-none">
              <span>{{t('about.us.public.title')}}</span>
            </div>
            <div class="shadow-box shadow-box--lg p-3 h-100">
              <h3 class="pb-4 fst-normal d-none d-md-inline-flex">
                {{t('about.us.public.title')}} </h3>
              <ul>
                <li>
                  <p>
                    {{t('about.us.public.title.1')}} </p>
                  <p class="pb-3">
                    {{t('about.us.public.content.1')}} </p>
                </li>
                <li>
                  <p>
                    {{t('about.us.public.title.2')}} </p>
                  <p class="pb-3">
                    {{t('about.us.public.content.2')}} </p>
                </li>
                <li>
                  <p>
                    {{t('about.us.public.title.3')}} </p>
                  <p class="pb-3">
                    {{t('about.us.public.content.3')}} </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="mobile-subtitle fs-18 fw-medium mt-3 d-flex d-md-none">
              <span>{{t('about.us.organiser.title')}}</span>
            </div>
            <div class="shadow-box shadow-box--lg p-3">
              <h3 class="pb-4 fst-normal d-none d-md-inline-flex">
                {{t('about.us.organiser.title')}} </h3>
              <ul>
                <li>
                  <p>
                    {{t('about.us.organiser.title.1')}} </p>
                  <p class="pb-3">
                    {{t('about.us.organiser.content.1')}} </p>
                </li>
                <li>
                  <p>
                    {{t('about.us.organiser.title.2')}} </p>
                  <p class="pb-3">
                    {{t('about.us.organiser.content.2')}} </p>
                </li>
                <li>
                  <p>
                    {{t('about.us.organiser.title.3')}} </p>
                  <p>
                    {{t('about.us.organiser.content.3')}} </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="grey-neutral-50-bg py-4">
      <div class="container">
        <div class="row pb-4">
          <div class="col-12">
            <h1 class="text-center d-none d-md-inline-flex">
              {{t('about.us.numbers.title')}} </h1>
            <div class="justify-content-center d-md-none d-flex fs-26 fw-medium">
              {{t('about.us.numbers.title')}}
            </div>
          </div>
        </div>
        <div class="row pb-3">
          <div class="col-6 col-md-3">
            <div class="shadow-box d-flex flex-column justify-content-center align-items-center p-3">
              <p class="large pb-3 text-uppercase">{{t('about.us.numbers.first.race')}}</p>
              <h1 class="d-none d-md-block">{{t("about.us.numbers.first.race.year")}}</h1>
              <h2 class="d-block text-center d-md-none mobile-subtitle w-100">
                {{t("about.us.numbers.first.race.year")}}
              </h2>
            </div>
          </div>
          <div class="col-6 col-md-3 text-center">
            <div class="shadow-box d-flex flex-column justify-content-center align-items-center p-3">
              <p class="large pb-3 text-uppercase">{{t('about.us.numbers.race')}}</p>
              <h1 class="d-none d-md-block">{{t('about.us.numbers.race.number')}}</h1>
              <h2 class="d-block d-md-none mobile-subtitle w-100">
                {{t("about.us.numbers.race.number")}}
              </h2>
            </div>
          </div>
          <div class="col-6 col-md-3 text-center">
            <div class="shadow-box d-flex flex-column justify-content-center align-items-center p-3">
              <p class="large pb-3 text-uppercase">{{t('about.us.numbers.competitors')}}</p>
              <h1 class="d-none d-md-block">{{t('about.us.numbers.competitors.number')}}</h1>
              <h2 class="d-block d-md-none mobile-subtitle w-100">
                {{t("about.us.numbers.competitors.number")}}
              </h2>
            </div>
          </div>
          <div class="col-6 col-md-3 text-center">
            <div class="shadow-box d-flex flex-column justify-content-center align-items-center p-3">
              <p class="large pb-3 text-uppercase">{{t('about.us.numbers.partners')}}</p>
              <h1 class="d-none d-md-block">{{t('about.us.numbers.partners.number')}}</h1>
              <h2 class="d-block d-md-none mobile-subtitle w-100">
                {{t("about.us.numbers.partners.number")}}
              </h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-21 col-md-8 mx-auto">
            <img [src]="publicMobileModuleUrl" alt="" class="img-fluid">
          </div>
        </div>
      </div>
    </section>

    <section class="bg-teal-100 py-4 d-none d-md-flex">
      <div class="container">
        <div class="row">
          <div class="col-3">
            <p class="medium fw-medium">
              {{t('about.us.contact')}} </p>
            <p>{{t('app.common.headquartersName')}}</p>
            <p>
              {{
                environment.headquartersStreet + ', ' +
                environment.headquartersCity + ' (' + t('app.common.headquartersCounty') + ')'
              }} </p>
            <p>
              <a class="text-black" href="mailto: {{environment.contactMail}}">{{environment.contactMail}}</a>
            </p>
          </div>
          <div class="col-3"></div>
          <div class="col-3">
            <p class="medium fw-medium">
              {{t('about.us.management')}} </p>
            <p>{{contactManagement}}</p>
            <a class="text-black" href="mailto:{{contactManagementMail}}">{{contactManagementMail}}</a>
            <p><a class="text-black" href="tel:{{contactManagementPhone}}">{{contactManagementPhone}}</a></p>
          </div>
          <div class="col-3">
            <p class="medium fw-medium">
              {{ t('about.us.helpdesk') }} </p>
            <a class="text-black" href="mailto:{{contactHelpdeskMail}}">{{contactHelpdeskMail}}</a>
          </div>
        </div>
      </div>
    </section>
  </app-page-template>
</ng-container>
